import React from "react";
import { Link } from "react-router-dom";
import "./FeatureCardContent.css";

function FeatureCardContent({
  icon,
  badgeTitle,
  title,
  text,
  subtext,
  children,
  className = "",
}) {
  return (
    <div className={`feature-card-content ${className}`.trim()}>
      <div className="feature-card-content__inner">
        <div className="feature-card-content__icon" aria-hidden="true">
          {icon}
        </div>
        <div className="feature-card-content__badge">{badgeTitle}</div>
        <h3 className="feature-card-content__title">{title}</h3>
        <p className="feature-card-content__body">{text}</p>
        {subtext ? (
          <p className="feature-card-content__footnote">{subtext}</p>
        ) : null}
        {children}
        <Link to="/signup" className="feature-card-content__cta button--primary-new">
          Start saving up to 15% of billables
        </Link>
      </div>
    </div>
  );
}

export default FeatureCardContent;
